import React, { useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch } from 'react-redux';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';

import { START_DRAG_MENU, QUIT_DRAG_MENU } from './reducer';

// 한 번에 요청할 item 수 
const PER_PAGE = 30;

const useStyle = makeStyles({
  root: {

  },
  item: {
    height: '40px',
  },
  content: {
    height: '34px',
    display: 'flex',
    border: '1px solid #cccccc',
    borderRadius: '4px',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0 10px'
  },
  index: {
    width: '24px',
    fontSize: '12px',
    color: '#888888',
    marginRight: '10px'
  },
  supplier: {
    width: '80px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: '12px',
    fontWeight: 'bold',
    marginRight: '10px'
  },
  menu: {
    flexGrow: '1',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: '12px',
  },
  price: {
    fontSize: '12px',
  }
})

// zero padding 
const getIndexString = index => (index + 1).toString().padStart(2, '0');

// korean won 
const krwFormat = new Intl.NumberFormat('ko-KR', {
  style: 'currency', currency: 'KRW'
});
const getPriceString = price => krwFormat.format(price);

const List  = ({ fetchData }) => {

  const dispatch = useDispatch();
  const classes = useStyle();

  // menu items 
  const [ items, setItems ] = useState([]);
  // total item count 
  const [ itemCount, setItemCount ] = useState(1);  // 최초 로딩 위해 기본값 1 
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState();

  const isItemLoaded = index => {    
    return items.length === itemCount || index < items.length;
  }

  const loadMore = async (startIndex, stopIndex) => {

    if (loading || startIndex >= itemCount) return ; // do nothing 

    try {
      setLoading(true);

      // load next page 
      const nextPage = Math.ceil(items.length / PER_PAGE) + 1;
      const { total, data } = await fetchData(nextPage, PER_PAGE);

      // update items, itemCount 
      setItems(items.concat(data));
      setItemCount(total);

      setLoading(false);
    } catch (err) {
      console.error(err)
      setLoading(false);
      setError(err);
    }
  };

  const handleDragStart = useCallback(evt => {
    const index = parseInt(evt.currentTarget.getAttribute('data-index'), 10);
    const menu = items[index];
    evt.dataTransfer.setData('text', JSON.stringify(menu));
  });
  // }, [ items ]); TEST

  const handleDragEnd = useCallback(() => {
    // ... 
  });

  const ListItem = ({ index, style }) => 
    isItemLoaded(index) ? (
      <div
        className={classes.item}
        style={style}
        key={index}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        draggable="true"
        data-index={index}
        >
        <div className={classes.content}>
          <div className={classes.index}>{getIndexString(index)}</div>
          <div className={classes.supplier}>{items[index].supplier?.name ?? '삭제됨'}</div>
          <div className={classes.menu}>{items[index].name}</div>
          <div className={classes.price}>{getPriceString(items[index].price)}</div>
        </div>
      </div>
    ) : (
      <div
        className={classes.item}
        style={style}
        key={index}>
        <div className={classes.content}>
          <div className={classes.index}>{getIndexString(index)}</div>
          <div className={classes.menu}>loading ... </div>
        </div>
      </div>
    );

  return (
    <div 
      className={classes.root}
    >
      <InfiniteLoader
        isItemLoaded={isItemLoaded}
        loadMoreItems={loadMore}
        itemCount={itemCount}
      >
        {({ onItemsRendered, ref }) => (
          <FixedSizeList
            width={400}
            height={420}
            itemSize={40}
            itemCount={itemCount}
            onItemsRendered={onItemsRendered}
            ref={ref}
          >
            {ListItem}
          </FixedSizeList>
        )}
      </InfiniteLoader>
    </div>
  );
}

export default List;